import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import PlotBarChart from "../../components/Common/Charts/PlotBarChart";
import React, { useEffect, useState } from "react";
import WebinarAverageCharts from "./WebinarAverageCharts";
import { Box, CardContent, Typography } from "@mui/material";
import { Card, CardBody, Col, Row } from "reactstrap";

const WebinarPerfomance = ({ webinarPerfomanceData }) => {

  // New Unique colors for additional charts
  const agendaColor = ['#fcd3a4']; // Tomato
  const participationColor = ['#A2CCFA']; // Steel Blue
  const recapColor = ['#a3eea3']; // Blue Violet
  const assessmentDiscussedColor = ['#A9C6FE']; // Orange Red
  const lmsContentColor = ['#FFA3A5']; // Sea Green
  const summaryNextStepsColor = ['#e4c0a6']; // Chocolate
  const slidesUsedColor = ['#7cb9b2']; // Dark Goldenrod
  const interactiveToolsColor = ['#82a4b1']; // Dark Slate Blue
  const connectivityIssueColor = ['#eed3d9']; // Crimson

  // {
  //     "weekly_session_agenda": {
  //         "07-07-2025": 0,
  //         "14-07-2025": 50,
  //         "21-07-2025": 0,
  //         "28-07-2025": 0,
  //         "04-08-2025": 0,
  //         "11-08-2025": 0,
  //         "18-08-2025": 0,
  //         "25-08-2025": 0
  //     },
  //     "weekly_is_encouraged": {
  //         "07-07-2025": 0,
  //         "14-07-2025": 100,
  //         "21-07-2025": 0,
  //         "28-07-2025": 0,
  //         "04-08-2025": 0,
  //         "11-08-2025": 0,
  //         "18-08-2025": 0,
  //         "25-08-2025": 0
  //     },
  //     "weekly_recap_provided": {
  //         "07-07-2025": 0,
  //         "14-07-2025": 0,
  //         "21-07-2025": 0,
  //         "28-07-2025": 0,
  //         "04-08-2025": 0,
  //         "11-08-2025": 0,
  //         "18-08-2025": 0,
  //         "25-08-2025": 0
  //     },
  //     "weekly_assessment_discussed": {
  //         "07-07-2025": 0,
  //         "14-07-2025": 100,
  //         "21-07-2025": 0,
  //         "28-07-2025": 0,
  //         "04-08-2025": 0,
  //         "11-08-2025": 0,
  //         "18-08-2025": 0,
  //         "25-08-2025": 0
  //     },
  //     "weekly_content_reference": {
  //         "07-07-2025": 0,
  //         "14-07-2025": 50,
  //         "21-07-2025": 0,
  //         "28-07-2025": 0,
  //         "04-08-2025": 0,
  //         "11-08-2025": 0,
  //         "18-08-2025": 0,
  //         "25-08-2025": 0
  //     },
  //     "weekly_session_summary": {
  //         "07-07-2025": 0,
  //         "14-07-2025": 100,
  //         "21-07-2025": 0,
  //         "28-07-2025": 0,
  //         "04-08-2025": 0,
  //         "11-08-2025": 0,
  //         "18-08-2025": 0,
  //         "25-08-2025": 0
  //     },
  //     "weekly_is_slides_used": {
  //         "07-07-2025": 0,
  //         "14-07-2025": 50,
  //         "21-07-2025": 0,
  //         "28-07-2025": 0,
  //         "04-08-2025": 0,
  //         "11-08-2025": 0,
  //         "18-08-2025": 0,
  //         "25-08-2025": 0
  //     },
  //     "weekly_interactive_tools_used": {
  //         "07-07-2025": 0,
  //         "14-07-2025": 100,
  //         "21-07-2025": 0,
  //         "28-07-2025": 0,
  //         "04-08-2025": 0,
  //         "11-08-2025": 0,
  //         "18-08-2025": 0,
  //         "25-08-2025": 0
  //     },
  //     "weekly_connectivity_issues": {
  //         "07-07-2025": 0,
  //         "14-07-2025": 0,
  //         "21-07-2025": 0,
  //         "28-07-2025": 0,
  //         "04-08-2025": 0,
  //         "11-08-2025": 0,
  //         "18-08-2025": 0,
  //         "25-08-2025": 0
  //     },
  //     "webinar_session_sentiments": {
  //         "07-07-2025": {
  //             "positive": 0,
  //             "neutral": 0,
  //             "negative": 0
  //         },
  //         "14-07-2025": {
  //             "positive": 100,
  //             "neutral": 0,
  //             "negative": 0
  //         },
  //         "21-07-2025": {
  //             "positive": 0,
  //             "neutral": 0,
  //             "negative": 0
  //         },
  //         "28-07-2025": {
  //             "positive": 0,
  //             "neutral": 0,
  //             "negative": 0
  //         },
  //         "04-08-2025": {
  //             "positive": 0,
  //             "neutral": 0,
  //             "negative": 0
  //         },
  //         "11-08-2025": {
  //             "positive": 0,
  //             "neutral": 0,
  //             "negative": 0
  //         },
  //         "18-08-2025": {
  //             "positive": 0,
  //             "neutral": 0,
  //             "negative": 0
  //         },
  //         "25-08-2025": {
  //             "positive": 0,
  //             "neutral": 0,
  //             "negative": 0
  //         }
  //     },
  //     "weekly_clarity_score": {
  //         "25-08-2025": 0
  //     },
  //     "weekly_webinar_coverage_score": {
  //         "25-08-2025": 0
  //     },
  //     "weekly_instructor_engagement_score": {
  //         "25-08-2025": 0
  //     },
  //     "weekly_student_sentiment_score": {
  //         "25-08-2025": 0
  //     },
  //     "weekly_fluency_score": {
  //         "25-08-2025": 0
  //     },
  //     "weekly_overall_session_quality_score": {
  //         "25-08-2025": 0
  //     }
  // }

  if (!webinarPerfomanceData) {
    return (
      <div
        style={{
          backgroundColor: 'white',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: 200,
        }}
      >
        <Typography variant="p" color="text.secondary" align="center">
          Webinar Performance charts are not available
        </Typography>
      </div>
    );
  }
  const webinarAverageChartsDataProps = {
    averageOverallQualityData:
      webinarPerfomanceData?.weekly_overall_session_quality_score,
    averageClarityScoreData: webinarPerfomanceData?.weekly_clarity_score,
    averageWebinarCoverageData:
      webinarPerfomanceData?.weekly_webinar_coverage_score,
    averageEngagementScoreData:
      webinarPerfomanceData?.weekly_instructor_engagement_score, //????????????????????????????????
    averageStudentSentimentData:
      webinarPerfomanceData?.weekly_student_sentiment_score,
    averageResponseScoreData:
      webinarPerfomanceData?.weekly_responsiveness_score,
    averageTeacherTimeSpokenData:
      webinarPerfomanceData?.weekly_instructor_talktime,
    averageFluencyScoreData: webinarPerfomanceData?.weekly_fluency_score,
  };

  return (
    <Card className="mb-4  rounded-lg" style={{ borderTopLeftRadius: '0', borderRadius:"0" }}>
      <CardBody
        className="p-4"
        style={{
          minHeight: '200px',
        }}
      >
        {webinarPerfomanceData.weekly_overall_session_quality_score ? (
          <Row className="g-4">
            <WebinarAverageCharts {...webinarAverageChartsDataProps} />
            {/* New Charts based on your scenarios */}
            <Col md={6}>
              <Card className="h-full border border-gray-200 rounded-lg shadow-sm">
                <PlotBarChart
                  xAxisTitle="Week"
                  title="% Sessions: Agenda Outline "
                  yAxisTitle="% of Sessions"
                  barColors={agendaColor}
                  options={webinarPerfomanceData?.weekly_session_agenda}
                  suffix="%"
                />
              </Card>
            </Col>
            <Col md={6}>
              <Card className="h-full border border-gray-200 rounded-lg shadow-sm">
                <PlotBarChart
                  xAxisTitle="Week"
                  title="% Sessions: Student Encouraged Participation"
                  yAxisTitle="% of Sessions"
                  barColors={participationColor}
                  options={webinarPerfomanceData.weekly_is_encouraged}
                  suffix="%"
                />
              </Card>
            </Col>
            <Col md={6}>
              <Card className="h-full border border-gray-200 rounded-lg shadow-sm">
                <PlotBarChart
                  xAxisTitle="Week"
                  title="% Sessions: Previous Recap"
                  yAxisTitle="% of Sessions"
                  barColors={recapColor}
                  options={webinarPerfomanceData.weekly_recap_provided}
                  suffix="%"
                />
              </Card>
            </Col>
            <Col md={6}>
              <Card className="h-full border border-gray-200 rounded-lg shadow-sm">
                <PlotBarChart
                  xAxisTitle="Week"
                  title="% Sessions: Upcoming Assessment Discussed"
                  yAxisTitle="% of Sessions"
                  barColors={assessmentDiscussedColor}
                  options={webinarPerfomanceData.weekly_assessment_discussed}
                  suffix="%"
                />
              </Card>
            </Col>
            <Col md={6}>
              <Card className="h-full border border-gray-200 rounded-lg shadow-sm">
                <PlotBarChart
                  xAxisTitle="Week"
                  title="% Sessions: LMS Content Referred"
                  yAxisTitle="% of Sessions"
                  barColors={lmsContentColor}
                  options={webinarPerfomanceData.weekly_content_reference}
                  suffix="%"
                />
              </Card>
            </Col>
            <Col md={6}>
              <Card className="h-full border border-gray-200 rounded-lg shadow-sm">
                <PlotBarChart
                  xAxisTitle="Week"
                  title="% Sessions: Instructor Summary & Next Steps (%)"
                  yAxisTitle="% of Sessions"
                  barColors={summaryNextStepsColor}
                  options={webinarPerfomanceData.weekly_session_summary}
                  suffix="%"
                />
              </Card>
            </Col>
            <Col md={6}>
              <Card className="h-full border border-gray-200 rounded-lg shadow-sm">
                <PlotBarChart
                  xAxisTitle="Week"
                  title="% Sessions: Slides Usage"
                  yAxisTitle="% of Sessions"
                  barColors={slidesUsedColor}
                  options={webinarPerfomanceData.weekly_is_slides_used}
                  suffix="%"
                />
              </Card>
            </Col>
            <Col md={6}>
              <Card className="h-full border border-gray-200 rounded-lg shadow-sm">
                <PlotBarChart
                  xAxisTitle="Week"
                  title="% Sessions: Instructor Interactive Tools Usage"
                  yAxisTitle="% of Sessions"
                  barColors={interactiveToolsColor}
                  options={webinarPerfomanceData.weekly_interactive_tools_used}
                  suffix="%"
                />
              </Card>
            </Col>
            <Col md={6}>
              <Card className="h-full border border-gray-200 rounded-lg shadow-sm">
                <PlotBarChart
                  xAxisTitle="Week"
                  title="% Sessions: Connectivity Issues"
                  yAxisTitle="% of Sessions"
                  barColors={connectivityIssueColor}
                  options={webinarPerfomanceData.weekly_connectivity_issues}
                  suffix="%"
                />
              </Card>
            </Col>
          </Row>
        ) : (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100px', // Adjust height as needed
              width: '100%', // Ensure it takes full width if needed
            }}
          >
            <div class="col-12">
              <p class="text-muted w-100 mt-3 text-center">
                <>Please Select the week to view Call Insights</>
              </p>
            </div>
          </Box>
        )}
      </CardBody>
    </Card>
  );
};

export default WebinarPerfomance;
